import React, { useEffect, useState } from 'react'
import TagGenerator from '../../../../../components/FormElements/TagGenerator';
import DynamicForm from '../../../../../components/FormElements/DynamicForm';
import { FiUploadCloud } from "react-icons/fi";
import { useDispatch } from 'react-redux';
import usePostApi from '../../../../../config/hooks/api/post/usePostApi';
import { setError, setMessage } from '../../../../../store/common/generalSlice';
import { checkDimensions, checkIfFilesAreCorrectType, checkIfFilesAreTooBig, convertToFile } from '../../../../../config/utils';
import { Upload } from 'antd';
import { RiCloseCircleFill } from 'react-icons/ri';
import { nonSharedPostValidationSchema, sharedPostValidationSchema } from './schema';

const Post = ({ closeAddPost, refreshFeed, editData }) => {
    const dispatch = useDispatch()
    const { createPost, updatePost } = usePostApi()

    const [dataToUpdate, setDataToUpdate] = useState(null)
    const [form, setForm] = useState({
        name: 'addPostForm',
        formFields: [
            {
                name: 'title',
                type: 'text',
                label: { value: 'Add Title', style: '', classes: 'label-gray' },
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: '',
                icon: null
            },
        ]
    })

    const handleSubmit = async (values) => {
        try {
            let formData = new FormData()
            for (const key in values) {
                if (key == 'hashtags') {
                    for (let i = 0; i < values.hashtags.length; i++) {
                        formData.append(`hashTag[${i}]`, values[key][i])
                    }
                }
                else if (key == 'image' && values[key]) {
                    if (!checkIfFilesAreTooBig(values[key])) {
                        dispatch(setError('Image size should not exceeed 5mb'))
                        return
                    }
                    if (!checkIfFilesAreCorrectType(values[key])) {
                        if (!values[key].startsWith('https://' || 'http://')) {
                            dispatch(setError('Invalid type. Allowed formats are PNG, JPG'))
                            return
                        }
                    }
                    if (!(await checkDimensions(values[key]))) {
                        dispatch(setError('Invalid dimensions. Max allowed 800 X 600'))
                        return
                    }
                    formData.append(key, values[key])
                }
                else formData.append(key, values[key])
            }

            let response;
            if (editData && ((editData.type && editData.type.toLowerCase() == 'post') || editData?.pollOptions === undefined)) {
                response = await updatePost(formData, editData?.id)
            }
            else {
                response = await createPost(formData)
            }

            if (response) {
                dispatch(setMessage(response?.data?.message))
                setTimeout(() => {
                    refreshFeed()
                    closeAddPost()
                }, 1000);
            }
        } catch (error) {
            console.log(error)
        }
    };

    useEffect(() => {
        // Index to insert new objects
        const index = 1; //insert before password field

        // Insert new objects
        const nonSharedPostFormFields = [
            {
                name: 'image',
                type: 'custom',
                label: { value: '', style: '', classes: '' },
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: <PostImageUpload />,
                classes: '',
                icon: null
            },
            ...form.formFields.slice(0, index),
            {
                name: 'hashtags',
                type: 'custom',
                label: { value: 'Add #Hashtag', style: '', classes: 'label-gray' },
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: <TagGenerator limit={10} />,
                classes: '',
                icon: null
            },
            {
                name: 'description',
                type: 'textarea',
                label: { value: 'Add Description', style: '', classes: 'label-gray' },
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: '',
                icon: null
            },
            ...form.formFields.slice(index)
        ];
        setForm({
            formFields: editData && editData?.shareDescription ?
                [...form.formFields, {
                    name: 'shareDescription',
                    type: 'textarea',
                    label: { value: 'Share Description', style: '', classes: 'label-gray' },
                    placeholder: '',
                    width: { md: 24, sm: 24, xs: 24 },
                    component: null,
                    classes: '',
                    icon: null
                }] : nonSharedPostFormFields,
            formValidation:
                editData && editData?.shareDescription ?
                    sharedPostValidationSchema :
                    nonSharedPostValidationSchema
        })
    }, [])


    useEffect(() => {
        if (editData) {
            const data = {
                title: editData?.title
            }
            //case: edit shared post
            if (editData?.shareDescription) {
                data.shareDescription = editData?.shareDescription
            }
            else {
                // if(editData?.imageUrl){
                data.image = editData?.imageUrl
                // }
                data.hashtags = editData?.hashTags
                data.description = editData?.description
            }
            setDataToUpdate(data)
        }
    }, [editData])

    return (
        <DynamicForm
            id='postForm'
            onSubmit={handleSubmit}
            form={form}
            reset={true}
            editData={dataToUpdate}
        />
    )
}

export default Post





const PostImageUpload = (props) => {
    const { onChange } = props
    const [preview, setPreview] = useState('')
    const [editData, setEditData] = useState(props?.onEdit())

    const getImagePreview = (file) => {
        if (file) {
            onChange(file)
            // Create a preview URL
            const reader = new FileReader();
            reader.onload = (e) => {
                setPreview(e.target.result); // Set the preview URL
            };
            reader.readAsDataURL(file); // Read the file as a data URL
        } else {
            setPreview(''); // Reset preview if no file is selected
            onChange(null)
        }
    };

    const handleChange = (data) => {
        if (data) {
            if (data?.fileList.length) {
                getImagePreview(data?.file)
            }
            else {
                setPreview(null)
            }
        }
        else {
            setPreview(null)
        }
    }

    useEffect(() => {
        if(editData){
            setPreview(null)
            setPreview(editData)
        }
    }, [editData])

    useEffect(() => {
        if (!preview) {
            onChange(null)
            props?.onEdit(null)
        }
    }, [preview])

    return (
        <React.Fragment>
            {preview && (
                <div className='flex justify-end mb-2'>
                    <RiCloseCircleFill
                        className='text-lg cursor-pointer'
                        onClick={() => setPreview(null)}
                    />
                </div>
            )}
            <div
                className='
            w-full 
            flex 
            flex-col 
            justify-center 
            items-center 
            border-primary 
            border-2 
            border-dashed
            rounded
            h-[180px]
            w-full
        '
                style={{ backgroundColor: '#FEEDBF' }}
            >
                {!preview ? (
                    <div className='p-4'>
                        <Upload
                            beforeUpload={() => {
                                return false;
                            }}
                            className='upload cursor-pointer'
                            onChange={handleChange}
                        >
                            <div className='flex flex-col justify-center items-center'>
                                <FiUploadCloud className='text-5xl text-primary' />
                                <h6 className='heading-6 text-sm font-bold'>Upload a photo</h6>
                                <small className='font-semibold'>Supported formats are PNG and JPG</small>
                                <small className='font-semibold'>Photos are usually 400x300 or 800x600</small>
                            </div>
                        </Upload>

                    </div>
                ) : (
                    <img src={preview} alt='' className='img-fluid w-full h-full object-contain' />
                )}
            </div>
        </React.Fragment>
    )
}